export const Header = (function () {
	'use strict';

	let $menu, $menuButton, $menuItems, $subMenuParent, $subMenuItem, $body;

	function init() {
		$menu = $('.site-header__nav .nav-items');
		$menuButton = $('.mobile-menu-button');
		$menuItems = $('.site-header__nav .nav-items a'); // Select all menu items
		$body = $('body');
		$subMenuParent = $('.site-header .menu-item-has-children');
		$subMenuItem = $('.site-header .sub-menu a');

		events();
	}

	function events() {
		// Toggle menu when the menu button is clicked
		$menuButton.click(function () {
			toggleMenu();
		});

		// Close menu when a menu item is clicked
		$menuItems.click(function () {
			closeMenu();
		});
	}

	function toggleMenu() {
		if ($menu.hasClass('open')) {
			closeMenu();
		} else {
			openMenu();
		}
	}

	function openMenu() {
		$body.addClass('mobile-menu-open');
		$menu.addClass('open');
		$menuButton.addClass('open').attr('aria-expanded', 'true');
	}

	function closeMenu() {
		$body.removeClass('mobile-menu-open');
		$menu.removeClass('open');
		$menuButton.removeClass('open').attr('aria-expanded', 'false');
	}

	return {
		init: init,
	};
})();